<template>
  <div class="ticket-number-cell flex flex-col">
    <span class="ticket-number-cell__number">{{ ticketNumber }}</span>
    <span class="visually-hidden"> — </span>
    <span class="ticket-number-cell__title">{{ title }}</span>
  </div>
</template>

<script setup>
/**
 * @component TicketNumberCell
 * @description Cella composta per DataTable: mostra il numero ticket in piccolo (grigio, 12px)
 * sopra e il titolo (cf_short_title) sotto, separati da un separatore visivamente nascosto
 * per screen reader. Usare come `component` in una colonna di `DataTable.columns`.
 *
 * @prop {String} ticketNumber - Numero ticket (es. "INC-00123"), mostrato in grigio sopra.
 * @prop {String} title        - Titolo breve del ticket (cf_short_title), mostrato sotto.
 *
 * @slot — nessuno slot esposto
 */
defineProps({
  ticketNumber: { type: String, default: '' },
  title: { type: String, default: '' }
})
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.ticket-number-cell {
  gap: 2px;
}

.ticket-number-cell__number {
  font-size: $fontSmall;
  color: $textGray;
  line-height: 1.3;
}

.ticket-number-cell__title {
  line-height: 1.4;
}
</style>
